function e(){return!("undefined"==typeof AudioContext&&"undefined"==typeof webkitAudioContext)}export{e as hasAudioContext};
